export enum TIME_INTERVALS {
  TEN_MIN = 10,
  ONE_HOUR = 60,
  ONE_DAY = 1440,
  ONE_MONTH = 43200,
  ONE_YEAR = 525600,
}
